import { render, staticRenderFns } from "./ConfigPublisher.vue?vue&type=template&id=f0809716"
import script from "./ConfigPublisher.vue?vue&type=script&lang=js"
export * from "./ConfigPublisher.vue?vue&type=script&lang=js"
import style0 from "./ConfigPublisher.vue?vue&type=style&index=0&id=f0809716&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports